import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { DateTime } from "luxon";
import { environment } from "../../../environments/environment";
import { MatDateFormats, NativeDateAdapter } from "@angular/material/core";
@Injectable()
export class LuxonDateFormatter extends NgbDateParserFormatter {
	constructor() {
		super();
	}
	static getLocaleDateString(lang) {
		const formats = {
			AU: "dd/LL/yyyy",
			UK: "dd/LL/yyyy",
			US: "LL/dd/yyyy",
		};

		return formats[lang] || "dd/MM/yyyy";
	}

	static getLocaleDateStringToShow() {
		return LuxonDateFormatter.getLocaleDateString(
			environment.defaultCountryCode
		).replace(/L/g, "M");
	}

	parse(value: string): NgbDateStruct {
		if (value) {
			value = value.trim();
			return DateTime.fromFormat(
				value,
				LuxonDateFormatter.getLocaleDateString(environment.defaultCountryCode)
			);
		}
		return null;
	}

	format(date: NgbDateStruct): string {
		if (!date) {
			return "";
		}
		const mdt = DateTime.fromObject(date);
		if (!mdt.isValid) {
			return "";
		}
		return mdt.toFormat(
			LuxonDateFormatter.getLocaleDateString(environment.defaultCountryCode)
		);
	}
}

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
	format(date: Date, displayFormat: Object): string {
		if (displayFormat === "input") {
			let day: string = date.getDate().toString();
			day = +day < 10 ? "0" + day : day;
			let month: string = (date.getMonth() + 1).toString();
			month = +month < 10 ? "0" + month : month;
			let year = date.getFullYear();
			switch (environment.defaultCountryCode) {
				case "AU":
				case "UK":
					return `${day}/${month}/${year}`;
				case "US":
					return `${month}/${day}/${year}`;
			}

		}
		return date.toDateString();
	}
}

export const APP_DATE_FORMATS: MatDateFormats = {
	parse: {
		dateInput: { month: "short", year: "numeric", day: "numeric" }
	},
	display: {
		dateInput: "input",
		monthYearLabel: { year: "numeric", month: "numeric" },
		dateA11yLabel: {
			year: "numeric", month: "long", day: "numeric"
		},
		monthYearA11yLabel: { year: "numeric", month: "long" }
	}
};
